export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const GET_ALL_STATES_REQUEST = 'GET_ALL_STATES_REQUEST';
export const GET_ALL_STATES_SUCCESS = 'GET_ALL_STATES_SUCCESS';
export const GET_ALL_STATES_FAILURE = 'GET_ALL_STATES_FAILURE';
export const SET_SELECTED_STATE = 'SET_SELECTED_STATE';
export const SET_GUIDE_PAGE = 'SET_GUIDE_PAGE';


// WEBPACK FOOTER //
// ./src/store/constants/ActionTypes.js